export const APP_SOURCE = "XDR Incidents";
export const AUTO_ENRICHMENT_SOURCE = "Incident Enrichment Automation";
